<template lang="pug"></template>

<script>
export default {
    name: 'BotaoUsuarios',
    componentOptions: {
        title: 'Usuarios',
        actions: [
            [
                {
                    name: 'Usuários',
                    iconClass: 'lyra-icon lyra-user-cog',
                    showView: false,
                    action: 'abrirUsuarios',
                    route: 'Usuarios',
                    nameTranslationKey: 'mensagens.menuLateral.usuarios'
                }
            ]
        ]
    },

    methods: {
        abrirUsuarios() {
            if (this.$route.name !== 'Usuario') {
                this.$router.push({ name: 'Usuario' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
